
import React from 'react';
import PropTypes from 'prop-types';

import FlatballastedImg1 from '../InstallImages/FlatBallasted/FlatBallastedImg1';
import FlatballastedImg2 from '../InstallImages/FlatBallasted/FlatBallastedImg2';

import '../saleslogic.css';
import '../../../../../../grid.css';

const CorrugatedMetal = (props) => {
    const { firstName } = props;

    return (
        <div className="row" >
            <h1 className="arrayType">Flat Roof</h1>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">
                    {firstName}, Solvana typically mounts solar modules onto your roof using non-penetrating solutions, where ballasted racking components are placed on top of non-skid slip-sheets to eliminate potential micro-abrasion damage. After calculating the amount of weight required to secure the PV solar array in place on your flat roof, we assemble the racking system components and strategically place the correct number of ballasts on them as determined by Solvana&#39;s engineering team. Ballasted racking systems virtually eliminate penetrations and make the installation a breeze. If Solvana&#39;s structural engineering analysis determines that your building is not able to support a standard ballasted racking system safely, we may adopt alternate methods to install the racking components. In such cases, engineering may recommend structural improvements to your building that resolves the challenge; otherwise, we can use non-penetrating weightless attachment points where roofing components are welded to the roof or mechanically attached to roof framing members. If roof penetrations are the only viable solution, then Solvana will work with your roofer to seal any penetrations and reduce the chance of any leaks. Ultimately, the details come down to analyzing wind uploads, the amount of potential corrosion to the equipment and components from the elements, the amount of ballast required for your project, and the amount of weight your roof can support.  That&#39;s why we leave these decisions to Solvana’s engineers.
                </p>
                <p className="col span-2-of-3 installPics installPixRight">
                    <FlatballastedImg1 />
                </p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-2-of-3 installPics">
                    <FlatballastedImg2 />
                </p>
                <p className="col span-1-of-3 installText">
                    In this case, engineering may recommend structural improvements to your building that will resolve the challenge. Otherwise, we can use non-penetrating weightless attachment points where roofing components are welded to the roof or mechanically attached to roof framing members. If no other options will work and roof penetrations are the only viable solution, then we will work with your roofer or ours to seal any penetrations and reduce the chance of any leaks. Ultimately, the details come down to analyzing wind uploads, the amount of corrosion from the elements, the amount of ballast required for your project, and the amount of weight your roof can support.  That’s why we leave these decisions to the engineers.
                </p>

            </div>
        </div>
    );
};

CorrugatedMetal.propTypes = {
    firstName: PropTypes.string.isRequired,
};

export default CorrugatedMetal;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/FlatBallasted/FlatBallasted.js